import types from "../../actions/types"

export default function create(state, action) {
  switch (action.type) {
    case types.create: {
      return {
        ...state,
        createdId: undefined,
        error: undefined,
      }
    }
    case types.createSuccess:
      return {
        ...state,
        data: null,
        createdId: action.createdId,
        error: null,
      }
    case types.createError:
      return {
        ...state,
        error: action.error,
      }
    case types.createCancel:
      return state
    default:
      return state
  }
}
